const ZoomControl = (div, map) => {
  const controlDiv = div;
  const zoomClasses = 'map__control btn btn--circle btn--shadow btn--zoom';
  controlDiv.className = 'map__controls hide-on-mobile';

  // Add the control wrapper.
  const controlWrapper = global.document.createElement('div');
  controlDiv.appendChild(controlWrapper);

  // Create zoom in button.
  const zoomInButton = global.document.createElement('button');
  zoomInButton.className = `${zoomClasses} btn--zoom-in`;
  controlWrapper.appendChild(zoomInButton);

  // Create zoom out button.
  const zoomOutButton = global.document.createElement('button');
  zoomOutButton.className = `${zoomClasses} btn--zoom-out`;
  controlWrapper.appendChild(zoomOutButton);

  // Setup the click event listener - zoomIn
  global.google.maps.event.addDomListener(zoomInButton, 'click', () => {
    map.setZoom(map.getZoom() + 1);
  });

  // Setup the click event listener - zoomOut
  global.google.maps.event.addDomListener(zoomOutButton, 'click', () => {
    map.setZoom(map.getZoom() - 1);
  });

  // Prevent focus from sticking.
  global.google.maps.event.addDomListener(zoomInButton, 'mousedown', event => {
    event.preventDefault();
  });
  global.google.maps.event.addDomListener(zoomOutButton, 'mousedown', event => {
    event.preventDefault();
  });

  map.addListener('zoom_changed', () => {
    const currentZoomLevel = map.getZoom();
    if (currentZoomLevel < map.maxZoom) {
      zoomInButton.className = `${zoomClasses} btn--zoom-in`;
    } else {
      zoomInButton.className = `${zoomClasses} btn--zoom-in is-disabled`;
    }

    if (currentZoomLevel > map.minZoom) {
      zoomOutButton.className = `${zoomClasses} btn--zoom-out`;
    } else {
      zoomOutButton.className = `${zoomClasses} btn--zoom-out is-disabled`;
    }
  });
};

export default ZoomControl;



// WEBPACK FOOTER //
// ./screens/App/screens/GMap/ZoomControl.js